export default {
  LIST(state, data) {
    state.countries = data
  },
  UPDATE_COUNTRY(state, value) {
    state.country = { ...value }
  },
  FRESH_COUNTRY(state) {
    state.country = {
      id: null,
      name: {
        uz: '',
        ru: '',
        en: '',
      },
    }
  },
}
